module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAARVBMVEUAAAD/gAD/hgD/gAD/hgD/gAD/gAD/gwD/gAD/gwD/gAD/gAD/gAD/gAD/gAD/gAD/gAD/gAD/gAD/gAD/gAD/gAD///8EufE/AAAAFXRSTlMAEhMUFRwiIyQlOry9vr/Mzc7y8/QsNdNKAAAAAWJLR0QWfNGoGQAAAGNJREFUKM/lk0kKgEAMBNs9LqMzav3/q14U9JDBs9YtFA2BpKUbfdiDySMBiydLAArHNgA0X7d1ezIAMFxjLckSHsk04zNpy9hVIZu16Mqlk1Q5O1e/vODLf1bMdUE2beOjRwdH5RZ+7xTyTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/new.png
// module id = 179
// module chunks = 0